import configAxios from "../configuration/configAxios";
import {errorHandlerServices} from "../configuration/errorHandle";
import {useMutation, UseMutationResult, useQuery, UseQueryResult} from "@tanstack/react-query";
import queryClient from "../configuration/queryClient";
import {DepartmentInterface} from "../interface/DepartmentInterface";

export const getListAllDepartments = async () => {
    return await configAxios.get(`/ms-menus/departments/findAllDepartments`)
        .then(response => {
            return response.data.object
        }).catch(error => {
            errorHandlerServices(error, true)
            throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/departments/findAllDepartments`);
        })
}

export const useListAllDepartments = (): UseQueryResult<any, Error> => {
    return useQuery({queryKey: ['getListAllDepartments'], queryFn: () => getListAllDepartments()});
}


export const createDepartment = async (data: DepartmentInterface) => {
    return await configAxios.post(`/ms-menus/departments/createDepartment`, data).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return response.data.object
        }
    }).catch(error => {
        errorHandlerServices(error, true)
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/departments/createDepartment`);
    })
}

export const useCreateDepartment = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: DepartmentInterface) => createDepartment(data),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['getListAllDepartments']})
        }
    });
}

export const editDepartment = async (data: DepartmentInterface) => {
    return await configAxios.put(`/ms-menus/departments/editDepartment`, data).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return response.data.object
        }
    }).catch(error => {
        errorHandlerServices(error, true)
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/departments/editDepartment`);
    })
}

export const useEditDepartment = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: DepartmentInterface) => editDepartment(data),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['getListAllDepartments']})
        }
    });
}

export const deleteDepartment = async (data: DepartmentInterface) => {
    return await configAxios.delete(`/ms-menus/departments/deleteDepartment`, {
        params: {
            idDepartment: data.idDepartment
        }
    }).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return response.data.object
        }
    }).catch(error => {
        errorHandlerServices(error, true)
        throw new Error(error?.response?.data?.message ? error?.response?.data?.message : `Error service: /ms-menus/departments/deleteDepartment`);
    })
}

export const useDeleteDepartment = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: DepartmentInterface) => deleteDepartment(data),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['getListAllDepartments']})
        }
    });
}
